var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.group ? 'transition-group' : 'transition',_vm._b({tag:"component",attrs:{"name":`slide-toggle-${_vm.dimension}`},on:{"enter":_vm.onEnter,"after-enter":_vm.onAfterEnter,"before-leave":_vm.extend,"after-leave":_vm.onAfterLeave}},'component',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }